<template>
	<div class="main">
		<div class="product">
      <div class="pro"><router-link :to="{path:'/'}" class="link"><span >{{$t('nav.home')}} > </span></router-link><router-link :to="{path:'/about'}" class="link"><span >{{$t('nav.about')}} </span></router-link>>{{$t('zwlb')}}</div>
			<div class="jli" v-if="$i18n.locale == 'zh'">{{job.name}}</div>
			<div class="jli" v-else-if="$i18n.locale == 'en'">{{job.y_name}}</div>
			<div class="jli" v-else>{{job.e_name}}</div>
			<!--  -->
			<div class="las">{{$t('zpyq')}}</div>
			<div class='about' v-if="$i18n.locale == 'zh'" v-html='job.require'>
			</div>
			<div class='about' v-else-if="$i18n.locale == 'en'" v-html='job.y_require'>
			</div>
			<div class='about' v-else v-html='job.e_require'>
			</div>
			<!--  -->
			<div class="las">{{$t('gzzw')}}</div>
			<div class='about' v-if="$i18n.locale == 'zh'" v-html='job.duty'>
			</div>
			<div class='about' v-else-if="$i18n.locale == 'en'" v-html='job.y_duty'>
			</div>
			<div class='about' v-else v-html='job.e_duty'>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				job:{},
			}
		},
		mounted() {
			this.getPor()
		},
		methods: {
      getPor() {
				var that = this;
				this.$axios
					.post("/api/index/job_info", {
						id:this.$route.query.id
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.job = ret.data.data.job;
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
    }
	}
</script>

<style lang="scss" scoped>
	.main {
		background-color: #FFFFFF;
		width: 100%;
		display: flex;
		align-items: center;
		flex-direction: column;

		.introduce {
			width: 1200px;
			height: 433px;
			margin: 60px 0;
			display: flex;
			// align-items: center;
			justify-content: space-between;

			.ad {
				width: 800px;
				height: 433px;
			}

			.info {
				width: 800px;
				height: 433px;
				padding-left: 40px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.title {
					font-size: 30px;
					color: #004098;
					font-weight: bold;
				}

				span {
					display: block;
					width: 40px;
					height: 4px;
					background: #004098;
					margin-top: 20px;
				}

				.cro {
					font-size: 18px;
					color: #333;
					margin: 20px 0;
				}

				.text {
					height: 300px;

					p {
						font-size: 16px;
						color: #999;
						text-indent: 2em;
					}

				}
				.link {
					font-size: 16px;
					color: #004098;
					display: flex;
					align-items: center;
					cursor: pointer;

					.el-image {
						width: 16px;
						height: 16px;
						margin-left: 5px;
					}
				}
			}
			.info2 {
				background-color: #F7F8FA;
				padding: 50px 40px;
			}
		}
		.h_title {
			font-size: 30px;
			color: #004098;
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 1200px;
			padding: 40px 0;
			font-weight: bold;

			.el-image {
				width: 515px;
				height: 13px;
			}
		}

		.range {
			width: 1200px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.li {
				font-size: 16px;
				color: #333;
				display: flex;
				align-items: center;
				flex-direction: column;

				.el-image {
					width: 70px;
					height: 70px;
					padding: 15px;
					margin-bottom: 15px;
					background-color: #004098;
				}
			}
		}

		.el-carousel {
			width: 1200px;
		}

		.product {
			width: 100%;
			background-color: #F7F8FA;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding-bottom: 60px;

			.list {
				width: 1200px;
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
                flex-wrap:wrap;
				.shop {
					width: 390px;
					height: 400px;
					background: #FFFFFF;
					padding: 20px;
					display: flex;
					flex-direction: column;
                    margin-bottom: 20px;
					.el-image {
						width: 350px;
						height: 260px;
					}
					.title {
						font-size: 20px;
						color: #333;
						margin: 15px 0;
					}

					.text {
						font-size: 16px;
						color: #666;
					}

					.link {
						font-size: 16px;
						color: #004098;
						display: flex;
						align-items: center;
						cursor: pointer;
						margin-top: 10px;

						.el-image {
							width: 16px;
							height: 16px;
							margin-left: 5px;
						}
					}
				}
			}
		}

        .pro{
            width: 1200px;
            line-height:30px;
            margin:40px 0 0;
            overflow: hidden;
            text-align: left;
        }	
        .about{
            width: 1200px;
            margin: 10px auto;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 30px;
            color: #333333;
        }
        .jli{
            width: 1200px;
            margin: 50px auto;
            overflow: hidden;
            font-size: 30px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333333;
        }
        .imgs .el-image{
            width: 20px;
            height: 20px;
            margin-top: 15px;
            margin-right: 20px;
            vertical-align:-5px;
        }
        .list_one{
            width: 1200px;
            margin: 0 auto;
            overflow: hidden;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 20px;
            color: #004098;
        }
        .pro_list{
            width: 1200px;
            margin: 0 auto;
            overflow: hidden;
        }
        .page{
            width: 1200px;
            text-align: right;
            overflow: hidden;
            margin:40px 0;
        }
        .las{
            width: 1200px;
            text-align: left;
            margin: 0px auto 40px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 30px;
            color: #004098;
        }
	}
</style>



// WEBPACK FOOTER //
// src/components/about/aboutdetail.vue